import { Api } from 'utils';

class AreaService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/areas',params),
		create: async (params?: any) => Api.createResponse('admin/areas/create',params),
		edit: async (params?: any) => Api.createResponse('admin/areas/edit',params),
		delete: async (params?: any) => Api.createResponse('admin/areas/delete',params),
	}

}

export default AreaService;